module.exports = __webpack_public_path__ + "src/app/_content/MINIFonts/fontello.eot?0ac97d5a0b396d802e44fcda958dbe0c";